import React from 'react';
import ForgotPasswordRequest from './ForgotPasswordRequest';
import './forgot.css';

export default function ForgotPasswordModal({ open, onClose, showAlert, theme = 'dark' }) {
  if (!open) return null;
  return (
    <div className="fp-modal" role="dialog" aria-modal="true" onClick={onClose}>
      <div className={`fp-panel fp-theme-${theme}`} onClick={(e) => e.stopPropagation()}>
        <button aria-label="Close" className="fp-close" onClick={onClose}>×</button>
        <ForgotPasswordRequest showAlert={showAlert} />
      </div>
    </div>
  );
}
